
export default {
    name: 'EGames',
    data: () => ({
        columnPartition: 6,
        searchGame: '',
        filter: {
            product_type_code: '',
            provider_code: '',
            page: 1,
            limit: 20,
        },
    }),
    computed: {
        isMaintenance() {
            return this.$store.state.games.isMaintenance
        },
        gameTypes() {
            return this.$store.getters['games/gameTypes']
        },
        providers() {
            return this.$store.state.games.gameProviders
        },
        providersWithProductCode() {
            return this.$store.getters['games/providersWithProductCode']
        },
        games() {
            return this.$store.state.games.games
        },
        providerHasLobby() {
            return this.$store.getters['games/providerHasLobby']
        },
    },
    watch: {
        filter: {
            deep: true,
            handler(v) {
                this.filterGames()
            },
        },
        'filter.provider_code'(v) {
            this.gameTypes(v)
        },
        'filter.product_type_code'(v) {
            this.providersWithProductCode(v)
        },
        '$route.query'(newQuery) {
            this.filter.provider_code = newQuery.provider_code
            this.filter.product_type_code = newQuery.product_type_code
        },
        searchGame(v) {
            if (v.length > 1) {
                this.filter.game_name = v
                this.filterGames()
            }
        },
    },
    async mounted() {
        // Variables
        this.filter.product_type_code = this.$route.query.product_type_code
        this.filter.provider_code = this.$route.query.provider_code

        // Game types
        await this.$store.dispatch('games/gameTypes')

        // Game providers
        await this.$store.dispatch('games/gameProviders')

        // Games
        this.filterGames()
    },
    methods: {
        findImage(path) {
            if (path) {
                return `${this.$config.BUCKET}/assets/images/${path}`
            } else {
                return '/no-image.jpeg'
            }
        },
        filterGames() {
            this.$store.dispatch('games/games', this.filter)
        },
    },
}
